<template>
  <v-app id="default">
    <!-- style="background-color:#edffea"-->
    <v-content>
      <v-fade-transition>
        <div v-if="fullLoading" class="loaderOverlay">
          <div class="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      </v-fade-transition>
      <app-bar v-if="$route.path != '/login'" />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
  import { auth } from "@/firebase.js";
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";

  export default {
    components: {
      AppBar,
    },
    computed: {
      ...mapGetters(["fullLoading", "currentUser", "currentUserData"]),
    },
    data: () => ({
      bottomBarVisible: true,
      clipped: true,
      drawerRoutes: {},
    }),
    watch: {
      currentUser: function (oldData, newData) {
        var ts = Math.round(new Date().getTime() / 1000);
        if (
          this.currentUser != null &&
          this.currentUser != "loading" &&
          this.currentUser.idToken.payload.exp > ts
        ) {
          if (this.$route.path === "/login") {
            this.$router.push("/");
          }
        } else {
          if (this.$route.path != "/login") {
            this.$router.push("/login");
          }
        }
      },
    },
    mounted() {
      var ts = Math.round(new Date().getTime() / 1000);
      if (
        this.currentUser != null &&
        this.currentUser != "loading" &&
        this.currentUser.idToken.payload.exp > ts
      ) {
        console.log(3);
        if (this.$route.path === "/login") {
          console.log(4);
          this.$router.push("/");
        }
      } else if (this.currentUser != "loading") {
        console.log(5);
        if (this.$route.path != "/login") {
          console.log(6);
          this.$router.push("/login");
        }
      }
    },
  };
</script>

<style>
  html {
    overflow-y: auto;
  }

  .v-card__text {
    padding-bottom: 0px !important;
    padding-top: 14px !important;
  }

  ​ .v-bottom-navigation .v-btn {
    height: inherit !important;
  }

  .swal2-container {
    font-family: Helvetica;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb {
    background: #252729;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #4a4a4b;
  }
</style>

<style scoped>
  .loaderOverlay {
    z-index: 9999;
    background: #ffffff;
    width: 100vw;
    height: 100vh;
    position: fixed;
  }
  .lds-ripple {
    top: calc(50vh - 40px);
    left: calc(50vw - 40px);
    display: inline-block;
    position: fixed;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #252729;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
</style>
